import * as React from "react";
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { messages } from "../../utils/i18n/i18n";
import { useTranslation } from "../../utils/i18n/lang";
import { DialogContentProps } from "@mui/material/DialogContent/DialogContent";

interface Props {
    onCancel: () => void;
    children: React.ReactNode;
    cancelBtnLabel?: React.ReactNode;
    title?: React.ReactNode;
    mainAction?: React.ReactNode;
    contentSx?: DialogContentProps["sx"];
}

export const CancelableDialogBody = (p: Props) => {
    const m = useTranslation(msg);

    return (
        <>
            {p.title && <DialogTitle>{p.title}</DialogTitle>}
            <DialogContent sx={p.contentSx}>{p.children}</DialogContent>
            <DialogActions>
                <Button onClick={p.onCancel}>
                    {p.cancelBtnLabel == null ? m.cancelBtn : p.cancelBtnLabel}
                </Button>
                {p.mainAction}
            </DialogActions>
        </>
    );
};

const msg = messages(
    {
        cancelBtn: "Cancel",
    },
    {
        cs: {
            cancelBtn: "Storno",
        },
    }
);
